<div class="d-flex justify-content-center flex-column">
  <div class="row m-5">
    <div class="w-100 text-center">
      <button mat-flat-button color="primary" [routerLink]="['/']" routerLinkActive="router-link-active">
        <mat-icon>home</mat-icon> Se connecter
      </button>
    </div>
  </div>
</div>
